import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './componenti/AuthContext';
import App from './App';
import './index.css'; // ✅ Importa gli stili globali

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter future={{ v7_relativeSplatPath: true,
                            v7_startTransition: true
   }}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);




